import { decorateWithTimestampsForFirestore, getDataWithId } from './FirestoreUtils'

class Members {
  constructor (orgRef) {
    this.members = orgRef.collection('members')
  }
  ref (email) {
    return this.members.doc(email)
  }
  async updateMemberIfExists (member) {
    try {
      let memberToSave = Object.assign({}, member)
      delete memberToSave.organization
      delete memberToSave.email
      decorateWithTimestampsForFirestore(memberToSave)
      await this.members.doc(member.email).update(memberToSave)
    } catch (memberDoesNotExist) {
      /** Ignore: only update existing members (avoid adding souschef admins). */
    }
  }
}

export default class OrganizationService {
  constructor (db) {
    this.organizations = db.collection('organizations')
  }

  ref (id) {
    let org = this.organizations.doc(id)
    org.members = new Members(org)
    return org
  }

  setOrganization (id) {
    this.current = this.organizations.doc(id)
    this.current.members = new Members(this.current)
  }

  updateOrganization (org) {
    let orgToSave = Object.assign({}, org)
    delete orgToSave.id
    return this.organizations.doc(org.id).set(orgToSave, { merge: true })
  }

  async getOrganizations () {
    let organizations = []
    let snapshot = await this.organizations.get()
    if (snapshot.size > 0) {
      snapshot.docs.forEach(orgDoc => {
        let org = getDataWithId(orgDoc)
        if (!org.sheets) { org.sheets = {} }
        if (!org.sheets.landscapeExport) { org.sheets.landscapeExport = '' }
        if (!org.sheets.portraitExport) { org.sheets.portraitExport = '' }
        if (!org.sheets.deltaExport) { org.sheets.deltaExport = '' }
        organizations.push(org)
      })
    }
    return organizations
  }

  getOrganization (organizationId) {
    return this.organizations.doc(organizationId).get()
      .then(doc => {
        let organization = doc.exists ? doc.data() : {}
        organization.id = organizationId
        return organization
      })
  }

  async createOrganization (organization) {
    let doc = { exists: true }
    let counter = 0
    let orgId = ''
    while (doc.exists) {
      orgId = counter === 0 ? organization.name : (organization.name + counter)
      doc = await this.organizations.doc(orgId).get()
      counter++
    }
    let orgToSave = {
      name: organization.name,
      currency: organization.currency,
      sheets: { deltaExport: '', landscapeExport: '', portraitExport: '' }
    }
    decorateWithTimestampsForFirestore(orgToSave)
    let location = { name: organization.locations[0].name, address: organization.locations[0].address }
    await this.organizations.doc(orgId).set(orgToSave)
    await this.organizations.doc(orgId).collection('locations').doc('default').set(location)
    for (let i = 0; i < organization.members.length; i++) {
      await this.organizations.doc(orgId).collection('members').doc(organization.members[i]).set({})
    }
    return orgId
  }

  joinOrganization (userUid, organizationId) {
    // need to redoo
    return this.organizations.doc(organizationId).get().then(doc => {
      if (doc.exists) {
        // return this.users.doc(userUid).update({ organization: organizationId })
      } else {
        return Promise.reject(new Error('Organization does not exist.'))
      }
    })
  }
}
